"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = __importDefault(require("../title/index"));
const button_1 = __importStar(require("@app/routes/SpeechDevelopment/button"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const smallHeader_1 = __importDefault(require("@components/smallHeader"));
const gold_svg_1 = __importDefault(require("@components/icons/gold.svg"));
const almaz_svg_1 = __importDefault(require("@components/icons/almaz.svg"));
const rubin_svg_1 = __importDefault(require("@components/icons/rubin.svg"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const audioPathNames_1 = require("@app/enums/audioPathNames");
const ContainerExercise = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
    font-family: Phenomena;
    padding: 40px;
    @media (max-width: 400px) {
        padding: 16px;
        padding: 16px;
    }
    @media (max-height: 570px) {
        margin-top: 55px;
    }
    @media (max-height: 460px) {
        margin-top: 55px;
    }
`;
const ExerciseWrapper = styled_components_1.default.div `
    width: 100%;
    max-width: 100%;
    padding: 20px 35px;
    border-radius: 50px;
    border: 3px solid #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 12px;
    justify-content: space-between;
    margin-top: ${(props) => props.wihMargin ? "58px" : 0};
    height: max-content;
    @media (max-width: 400px) {
        border: 0;
        box-shadow: none;
        width: calc(100vw - 10px);
        margin-left: 5px;
        margin-right: 5px;
    }
`;
const DropContainerWrapper = styled_components_1.default.div `
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    align-items: self-start;
    justify-content: end;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
`;
const Pagination = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    gap: 12px;
`;
const PaginationItem = styled_components_1.default.span `
    background: #AEBBD2CF;
    width: 40px;
    height: 20px;
    border-radius: 50px;
    background: ${(props) => props.active ? props.active : "#AEBBD2CF"};
    border: ${(props) => props.active ? "3px solid #fff" : 0};
`;
const ImagesWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    max-width: 130px;
    gap: 20px;
    align-items: center;
    justify-content: center;
`;
const Description = styled_components_1.default.div `
    font-size: 30px;
    font-weight: bold;
    color: white;
    text-align: center;
    @media (max-width: 850px) {
        font-size: 18px;
        padding: 4px 15px;
    }

    @media (max-width: 540px) {
        font-size: 18px;
        padding: 3px 10px;
        font-weight: 700;
    }
`;
const IconWrapper = styled_components_1.default.span `
    position: relative;
    display: flex;
    justify-content: center;
    max-width: 130px;
    max-height: 150px;
    width: 100%;
    align-items: flex-end; // Используйте flex-end для выравнивания по нижнему краю
    height: auto; // Автоматическая высота, чтобы избежать избыточного пространства
    flex-grow: 1; // Позволяет иконкам занимать равное пространство
    margin: 0 auto; // Центрирование иконок внутри родителя
    @media (max-width: 768px) {
        max-width: 100px; // Уменьшите максимальную ширину для мобильных устройств
    }
    @media (max-height: 900px) {
        max-width: 100px;
        max-height: 100px;
    }
    @media (max-height: 850px) {
        max-height: 70px;
        margin-bottom: 30px;
    }
    @media (max-height: 750px) {
        max-height: 45px;
        margin-bottom: 45px;
    }
    @media (max-height: 710px) {
        max-height: 20px;
        margin-bottom: 60px;
    }
    @media (max-height: 700px) {
        max-height: 13px;
        max-width: 60px;
    }
    @media (max-height: 684px) {
        max-height: 50px;
        margin-bottom: 10px;
    }
`;
const IconQuantity = styled_components_1.default.span `
    position: absolute;
    width: calc(100% - 30px);
    padding: 8px 20px 8px 20px;
    gap: 8px;
    border-radius: 90px;
    background: #FE2B45;
    background: ${(props) => props.bg};
    color: #FFFFFF;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    font-family: inter;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: -10%;
    @media (max-height: 700px) {
        width: calc(100% - 50px);
        font-size: 16px;
        line-height: 10px;
        gap: 2px;
        bottom: 80%;
    }
    @media (max-height: 684px) {
        width: calc(100% - 50px);
        font-size: 16px;
        line-height: 10px;
        gap: 2px;

    }
    @media (max-height: 684px) {
        bottom: 40%;
    }
`;
// Компонент для отображения слова
const Container = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    //width: 100%;
    align-items: self-start;
    justify-content: center;
    flex-wrap: wrap;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
`;
const GroupContainer = styled_components_1.default.div `
    display: flex;
    margin: 16px;
    padding: 8px;
    flex-wrap: wrap;
    border: 1px solid #000;
    width: max-content;
    background-color: #f9f9f9;
    border-radius: 8px;
`;
const WordItem = styled_components_1.default.div `
    margin: 12px;
    background: transparent;
    padding: 5px 20px;
    border: 1px dashed #6E76FB; 
    border-radius: 25px;
    cursor: pointer;
    user-select: none;
    font-size: 50px;
    font-weight: 700;
    color: #6E76FB; 
    line-height: 40px;
    font-family: Phenomena;
    transition: background-color 0.2s ease-in-out;

    ${(props) => props.isCorrect !== undefined && `
        border: ${props.isCorrect ? '1px dashed #3CB949' : '1px dashed #FE2B45'};
        color: ${props.isCorrect ? '#3CB949' : '#FE2B45'};
    `}
    &:hover {
        background-color: #dcdcdc;
    }

    @media (max-width: 870px) {
        font-size: 30px;
        padding: 4px 15px;
    }

    @media (max-width: 540px) {
        font-size: 25px;
        padding: 3px 10px;
    }
    @media (max-height: 850px) {
        font-size: 18px;
        line-height: 16px;

    }
    @media (max-height: 744px) {
        font-size: 13px;
        line-height: 16px;
    }
`;
const Word = ({ word, index, moveWord, groupIndex }) => {
    const [, ref] = (0, react_dnd_1.useDrag)({
        type: 'WORD',
        item: { index, groupIndex },
    });
    const [, drop] = (0, react_dnd_1.useDrop)({
        accept: 'WORD',
        hover: (draggedItem) => {
            if (draggedItem.index !== index || draggedItem.groupIndex !== groupIndex) {
                moveWord(draggedItem.index, index, draggedItem.groupIndex, groupIndex);
                draggedItem.index = index;
                draggedItem.groupIndex = groupIndex;
            }
        },
    });
    return (
    // <WordsWrapper ref={(node) => ref(drop(node))}>
    react_1.default.createElement(WordItem, { ref: (node) => ref(drop(node)), isCorrect: word === null || word === void 0 ? void 0 : word.isCorrect }, word.word)
    // </WordsWrapper>
    );
};
const Group = ({ group, words, moveWord }) => (react_1.default.createElement(GroupContainer, null, words.map((word, index) => (react_1.default.createElement(Word, { key: word.word, word: word, index: index, moveWord: moveWord, groupIndex: group - 1 })))));
const groupAndSortItems = (items) => {
    const grouped = items.reduce((acc, item) => {
        if (!acc[item.group])
            acc[item.group] = [];
        acc[item.group].push(item);
        return acc;
    }, {});
    return Object.keys(grouped).map(key => grouped[Number(key)]);
};
const CompleteSentence = ({ response, description, langId }) => {
    var _a, _b;
    const [words, setWords] = (0, react_1.useState)([]);
    const [title, setTitle] = (0, react_1.useState)('');
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const getLabel = () => {
        if (+langId === 1) {
            return "Проверить";
        }
        return "Check";
    };
    const [checkButtons, setCheckButtons] = (0, react_1.useState)([{ isCorrect: false, index: 1, isChecked: false }, {
            isCorrect: false,
            index: 2,
            isChecked: false
        }, { isCorrect: false, index: 3, isChecked: false }, {
            isCorrect: false,
            index: 4,
            isChecked: false
        }, { isCorrect: false, index: 5, isChecked: false }, {
            isCorrect: false,
            index: 6,
            isChecked: false
        }, { isCorrect: false, index: 7, isChecked: false }, {
            isCorrect: false,
            index: 8,
            isChecked: false
        }, { isCorrect: false, index: 9, isChecked: false }, { isCorrect: false, index: 10, isChecked: false }]);
    const windowWidth = (0, useWindowWidrh_1.default)();
    const handleAddCoin = () => {
        addCoin(3, 5);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (response) {
            setTitle((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.title);
            setWords(groupAndSortItems(response === null || response === void 0 ? void 0 : response.form));
        }
    }, [response]);
    const checkSentence = () => {
        const checkCorrectSubArray = (subArray) => {
            const correctOrder = [...subArray].sort((a, b) => a.order - b.order);
            const groupMap = new Map();
            subArray.forEach((word) => {
                if (!groupMap.has(word.group)) {
                    groupMap.set(word.group, []);
                }
                groupMap.get(word.group).push(word);
            });
            if (groupMap.size === 1) {
                // Все слова имеют одну и ту же группу
                const group = [...groupMap.values()][0];
                const isCorrectOrder = group.every((word, index) => word.order === index + 1);
                return subArray.map(word => (Object.assign(Object.assign({}, word), { isCorrect: isCorrectOrder })));
            }
            else {
                // Если слова принадлежат разным группам или не находятся в правильном порядке
                return subArray.map(word => (Object.assign(Object.assign({}, word), { isCorrect: false })));
            }
        };
        const updatedSentence = words.map(subArray => {
            return checkCorrectSubArray(subArray);
        });
        setWords(updatedSentence);
        const isAllCorrect = updatedSentence.every(subArray => subArray.every(word => word.isCorrect));
        if (isAllCorrect) {
            handleAddCoin();
            audioPlayer_1.audioPlayer.playAudio(+langId === 1 ? audioPathNames_1.AudioPathNames.Correct : audioPathNames_1.AudioPathNames.Correct_en);
        }
        else {
            audioPlayer_1.audioPlayer.playAudio('x', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-318.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-318.mp3');
        }
        return isAllCorrect;
    };
    const handleCheckButtonClick = () => {
        setCheckButtons((prevButtons) => {
            const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
            if (indexToUpdate === -1)
                return prevButtons;
            return prevButtons.map((button, index) => {
                if (index === indexToUpdate) {
                    return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: checkSentence() });
                }
                return button;
            });
        });
    };
    const moveWord = (fromIndex, toIndex, fromGroupIndex, toGroupIndex) => {
        const updatedGroups = [...words];
        const [movedWord] = updatedGroups[fromGroupIndex].splice(fromIndex, 1);
        if (fromGroupIndex === toGroupIndex) {
            updatedGroups[toGroupIndex].splice(toIndex, 0, movedWord);
        }
        else {
            movedWord.group = toGroupIndex + 1;
            updatedGroups[toGroupIndex].splice(toIndex, 0, movedWord);
        }
        setWords(updatedGroups);
    };
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        windowWidth <= 1200 ? react_1.default.createElement(smallHeader_1.default, { exerciseName: ((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.title) || "Составление фраз и предложений" }) : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(ContainerExercise, null,
            windowWidth <= 1200 ? react_1.default.createElement(react_1.default.Fragment, null) :
                react_1.default.createElement(index_1.default, { text: ((_b = response === null || response === void 0 ? void 0 : response.text) === null || _b === void 0 ? void 0 : _b.title) || "Составление фраз и предложений" }),
            react_1.default.createElement(ExerciseWrapper, null,
                react_1.default.createElement(Description, null, description || ''),
                react_1.default.createElement(DropContainerWrapper, null, windowWidth > 700 ? react_1.default.createElement(ImagesWrapper, null,
                    react_1.default.createElement(IconWrapper, null,
                        react_1.default.createElement(gold_svg_1.default, null),
                        react_1.default.createElement(IconQuantity, { bg: "#F2A000" }, coinCount)),
                    react_1.default.createElement(IconWrapper, null,
                        react_1.default.createElement(rubin_svg_1.default, null),
                        react_1.default.createElement(IconQuantity, { bg: "#FE2B45" },
                            rubyCount,
                            " ")),
                    react_1.default.createElement(IconWrapper, null,
                        react_1.default.createElement(almaz_svg_1.default, null),
                        react_1.default.createElement(IconQuantity, { bg: "#13A3EA" }, diamondCount))) : react_1.default.createElement(react_1.default.Fragment, null)),
                react_1.default.createElement(Pagination, null, checkButtons.map((item, index) => react_1.default.createElement(PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)" : !item.isCorrect && item.isChecked ? "#FF1431" : null })))),
            react_1.default.createElement(button_1.ButtonContainerWrapper, null,
                react_1.default.createElement(button_1.default, { isShowShadow: false, label: getLabel(), onClick: handleCheckButtonClick, isCheckButton: true })))));
};
exports.default = CompleteSentence;
